/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useState, useMemo } from "react";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { useGetNigerianInstrumentsQuery } from "../../../../../../redux/apiSlice";
import { AsideMenu } from "../AsideMenu";
import { SearchBar } from "../../SearchBar";

export function NigerianInstrumentsMenu({ destination = "/instruments" }) {
    const { isFetching, data: nigerianInstruments } = useGetNigerianInstrumentsQuery()

    const [searchQuery, setSearchQuery] = useState("")
    const filteredInstruments = useMemo(
        () => nigerianInstruments?.data?.filter(
            (instrument) => instrument.symbol.toLowerCase().startsWith(searchQuery.toLowerCase()) || !searchQuery
        ),
        [nigerianInstruments, searchQuery]
    )

    return (
        <>
            <SearchBar
                placeholder={"Search Instruments"}
                isLoading={isFetching}
                onInput={(e) => setSearchQuery(e.target.value)}
            />
            {
                filteredInstruments?.map((instrument, i) => (
                    <AsideMenu.NavItem to={`${destination}/${instrument?.id}`} key={i}>
                        <div className="d-flex align-items-center">
                            <span
                                style={{
                                    height: "40px",
                                    width: "40px",
                                }}
                                className="mr-3 border svg-icon menu-icon rounded-circle bg-white d-flex align-items-center justify-content-center"
                            >
                                <img
                                    alt={instrument.symbol[0]}
                                    height="25px"
                                    width="25px"
                                    src={instrument.imageUrl}
                                    onError={e => {
                                        e.target.onerror = null;
                                        e.target.src = toAbsoluteUrl("/media/svg/icons/Shopping/Box3.svg")
                                    }}
                                />
                            </span>
                            <div className="flex-column align-items-start">
                                <div>
                                    {`${instrument.symbol}`.substring(0, 20)}
                                </div>
                                <div className="text-muted">
                                    {instrument.name.substring(0, 20)}
                                </div>
                            </div>
                        </div>
                    </AsideMenu.NavItem>
                ))
            }
        </>
    );
}
